import React from 'react';
import { useHistory } from 'react-router-dom';
import config from './config';

type DefaultProps = any;
export interface LogoProps extends DefaultProps {
  size?: number;
  link?: string;
}

const Logo = (props: LogoProps) => {
  const { link } = props;
  const size = props.size || 64;
  const history = useHistory();
  return link ? (
    <a
      href={link}
      onClick={
        link
          ? (e) => {
              history.push(link);
              e.preventDefault();
            }
          : undefined
      }
    >
      <img src={config.logoUrl} height={size} alt="Clinic logo" {...props} />
    </a>
  ) : (
    <img src={config.logoUrl} height={size} alt="Clinic logo" {...props} />
  );
};

export default Logo;
